import { Card, Stack, Typography } from "@mui/material";
import React from "react";

type NoneFoundProps = {
  title: React.ReactNode | string,
  message?: React.ReactNode | string,
  children?: React.ReactNode
}

export function NoneFoundNoCard({ title, message, children }: NoneFoundProps) {
  return <Stack direction="column" gap={3} paddingTop={5} paddingBottom={5} paddingLeft={5} paddingRight={5}>
    <Stack alignItems="center">
      <Typography variant="h4">
        {title}
      </Typography>
    </Stack>
    <Stack alignItems="center">
      <Typography variant="body2" textAlign="center" component="div">
        {message}
      </Typography>
    </Stack>

    <Stack display="flex" gap={1} flexDirection="row" justifyContent="center">
      {children}
    </Stack>
  </Stack>
}

export default function NoneFound({ title, message, children }: NoneFoundProps) {
  return <Card>
    <NoneFoundNoCard title={title} message={message} children={children} />
  </Card>
}